<script lang="ts" setup>
import { SortingProps } from "~/components/Filters/Utils/Dropdowns/Sorting.props"
import { SortingModalItemProps } from "~/components/Filters/Utils/SortingModalItem.props"
import { ifHasNameAndValueSetCoookie } from "~/utils/cookies/setCookie"

const props = defineProps<SortingProps>()
const emit =
  defineEmits<{
    (e: "onToggle"): void
    (e: "onSelectItem", item: SortingModalItemProps): void
  }>()

const { sortFilter } = useGA4SiteEvents()
const onclickdFilter = (filter: SortingModalItemProps) => {
  sortFilter(filter)
}

watchEffect(() => {
  const name = props.activeCookieName
  const value = props.currentActive

  ifHasNameAndValueSetCoookie(name, value)
})
</script>

<template>
  <FiltersUtilsDropdown
    content-class="min-w-[18rem] px-4 py-2 space-y-2"
    :text="sortBy"
    :opened="opened"
    attach-to="right"
    hide-controls
    @onToggle="emit('onToggle')"
  >
    <FiltersUtilsSortingModalItem
      v-for="(item, i) in items"
      :key="item.value"
      :="item"
      :active="item.value === currentActive"
      :hide-border="i === items.length - 1"
      less-spacing
      @onClick="
        () => {
          onclickdFilter(item)
          emit('onSelectItem', item)
        }
      "
    />
  </FiltersUtilsDropdown>
</template>
